"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgClientCard = function SvgClientCard(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 264 123",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C2C5CC",
    d: "M51 54h49v1H51zM4 117h49v1H4zm0-31h49v1H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 14 61 4m2 10L73 4m3 10L86 4m2 10L98 4m3 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m2 10 10-10M51 36l10-10m2 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m2 10 10-10m-58 97 10-10m2 10 10-10m3 10 10-10m2 10 10-10m3 10 10-10m3 10 10-10m40 10 10-10m-48 10 10-10m40 10 10-10m-47 10 10-10m40 10 10-10m-48 10 10-10m40 10 10-10M104 96l20-20m-7 20 20-20m-8 20 20-20m-7 20 20-20m-7 20 20-20m-8 20 20-20m18 20 20-20m5 20 20-20m-70 20 20-20m18 20 20-20m5 20 20-20m-71 20 20-20",
    stroke: "#C2C5CC",
    fill: "#C2C5CC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#C2C5CC",
    cx: 20,
    cy: 20,
    r: 19.5
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgClientCard);
var _default = exports["default"] = Memo;